import getCookie from 'src/js/utils/get-cookie';
import constants from '../constants';

const isAuthenticated = () => getCookie(constants.AUTH_COOKIE_NAME);

export default isAuthenticated;
